import lpApp from "../../app/lp_app";
import ConditionsEvo from "./../condition_evo";
import jsonLogic from "./wrapper";
import References from "./references";

class JsonLogicApplier {

    /**
     * Constuctor
     */
    constructor(conditions, copy = false, id = false) {

        // Making sure the conditions object if valid
        if(!("data_map" in conditions) || !("logic" in conditions))
            throw new Error('Conditions object is not a valid LP-JsonLogic');

        this.logic = conditions.logic;
        this.data_map = conditions.data_map;

        // Getting Multiples object from ConditionsEvo
        this.multiples = ConditionsEvo.multiples;

        // The id of the conditions
        this.id = parseInt(id);

        // Parents Tree
        this.parentsTree = References.getParentsTree();

        // Conditionned options list
        this.conditionnedOptions = References.getConditionnedOptions();

        // Multiples dependencies list
        this.multiplesDependencies = References.getMultiplesDependencies();

        // Populating data from data map
        this.data = this.populateData(copy);
    }

    /**
     * Populates data from lpApp according to the data_map
     * if it recieves the copy, it makes sure only data related
     * to that copy is filled instead of an array with all siblings values
     * @param {string} copy  - Multiple's copy
     */
    populateData(copy = false) {
        let data = {
            option: {},
            variable: {},
            condition: {}
        };

        // Getting options
        this.data_map.options.forEach((id) => {
            let value = lpApp.indexes.options.getOption(id).value;

            // Checking if it's a multiple
            let multiple_id = this.isOptionMultiple(id);

            if(multiple_id !== false){
                if (copy === false && !this.isOptionEligibleForMultiple(multiple_id)){
                    // Transforming to an array
                    value = [ value ];

                    if (this.multiples[multiple_id]) {
                        // Getting all copies
                        let copies = this.multiples[multiple_id].copies;
                        if(Array.isArray(copies)){
                            copies.forEach( (copy) => {
                                value.push( lpApp.indexes.options.getOption(id + '_' + copy).value );
                            });
                        }
                    }
                } else {
                    // If the copy isn't false we get the option's copy, otherwise, it's the index 0 of the multiple
                    let key = copy === false ? id : id + '_' + copy;
                    value = lpApp.indexes.options.getOption(key).value;
                }
            }

            data.option[id] = value;
        });

        // Getting variables
        this.data_map.variables.forEach((id) => {
            let value = lpApp.indexes.variables.getVariable(id).value;
            let parent_id = this.parentsTree.variables[id][0];

            // Checking if it's a multiple
            let multiple_id = this.isOptionMultiple(parent_id);
            if(multiple_id !== false){
                if(copy === false && !this.isOptionEligibleForMultiple(multiple_id)){
                    // Transforming to an array
                    value = [ value ];

                    // Getting all copies
                    let copies = this.multiples[multiple_id].copies;
                    if(Array.isArray(copies)){
                        copies.forEach( (copy) => {
                            value.push( lpApp.indexes.variables.getVariable(id + '_' + copy).value );
                        });
                    }
                } else {
                    // If the copy isn't false we get the variable's copy, otherwise, it's the index 0 of the multiple
                    let key = copy === false ? id : id + '_' + copy;
                    value = lpApp.indexes.variables.getVariable(key).value;
                }
            }

            data.variable[id] = value;
        });

        // Getting conditions
        this.data_map.conditions.forEach((id) => {
            let value = ConditionsEvo.getCondition(id);

            // Checking if it's a multiple
            let multiple_id = this.isOptionMultiple(id);
            if(multiple_id !== false){
                if(copy === false && !this.isOptionEligibleForMultiple(multiple_id)){
                    // Transforming to an array
                    value = [ value ];

                    // Getting all copies
                    let copies = this.multiples[multiple_id].copies;
                    if(Array.isArray(copies)){
                        copies.forEach( (copy) => {
                            const key = copy ? id + '_' + copy : id;
                            value.push( ConditionsEvo.getCondition(key) );
                        });
                    }
                } else {
                    const key = copy ? id + '_' + copy : id;
                    value =  ConditionsEvo.getCondition(key);
                }
            }

            data.condition[id] = value;
        });

        return data;
    }

    /**
     * Returns the parent multiple id if the option belongs to
     * a multiple, otherwise it returns false
     * @param {number} id - option's id
     */
    isOptionMultiple(id){
        let found = false;

        if(typeof(id) === 'undefined')
            throw new Error('Corrupt condition found on id '+this.id)

        // Checking if the option itself is multiple
        if(this.multiples.hasOwnProperty(id.toString())){
            found = id;
        }

        // Checking if it belongs to a multiple
        Object.keys(this.multiples).forEach((key) => {
            if(this.multiples[key].descendants.options.includes( parseInt(id, 10) )){
                found = key;
            }
        });

        // Checking if option is a child of a repeated option (it's considered as a multiple then)
        Object.keys(this.multiplesDependencies).forEach((key) => {
            if(this.multiplesDependencies[key].includes( parseInt(id, 10) )){
                found = key;
            }
        })

        return found;
    }

    /**
     * Checks if current copy is eligible for a multiple
     * @param {number} id
     */
    isOptionEligibleForMultiple(id){
        // Making sure copy is part of this multiple in case we recieve it
        if(this.id !== false && id !== false){
            if(!this.multiplesDependencies[id].includes(parseInt(this.id,10)))
                return false;
        }

        return true;
    }


  /**
   * Executes condition with jsonLogic
   */
  apply() {
    return jsonLogic.apply(this.logic, this.data);
  }
}

export default JsonLogicApplier;


// WEBPACK FOOTER //
// ./src/logic/jsonlogic/applier.js